import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function km1(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@km1/SAVE_KM1_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@km1/SAVE_KM1_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@km1/SAVE_KM1_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@km1/UPDATE_KM1_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@km1/UPDATE_KM1_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@km1/UPDATE_KM1_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}